import { useState, useEffect } from 'react';

import { useQuery } from '@tanstack/react-query';

import getChangeFieldName from '../helpers/getChangeFieldName';
import VendorService from '../../../../../services/VendorService';
import BorrowerService from '../../../../../services/BorrowerService';

export default function useSetEntityById({ type, document, setValue }) {
  const [isSet, setIsSet] = useState(false);

  const field = getChangeFieldName(type);

  const isVendor = ['agent_id', 'carrier_id', 'broker_id'].includes(field);
  const isBorrower = ['borrower_id', 'coborrower_id'].includes(field);

  const { data: vendor } = useQuery({
    queryKey: ['vendor', type, document?.parseur_result?.[field]],
    queryFn: () => VendorService.getVendor(document?.parseur_result?.[field]),
    enabled: isVendor && !!document?.parseur_result?.[field],
  });

  const { data: borrower } = useQuery({
    queryKey: ['borrower', type, document?.parseur_result?.[field]],
    queryFn: () =>
      BorrowerService.getBorrower(document?.parseur_result?.[field]),
    enabled: isBorrower && !!document?.parseur_result?.[field],
  });

  useEffect(() => {
    if (vendor) {
      setValue?.(vendor.name);
      setIsSet(true);
    }
  }, [setValue, vendor]);

  useEffect(() => {
    if (borrower) {
      setValue?.(borrower.name);
      setIsSet(true);
    }
  }, [setValue, borrower]);

  return isSet;
}
